import { Badge } from "@shopify/polaris";
import { CircleMinusMajor } from "@shopify/polaris-icons";

export default function NotStartedBadge() {
  return (
    <Badge status={"info"} icon={CircleMinusMajor}>
      Not started
    </Badge>
  );
}
